/* eslint-disable camelcase */
import { wrapRootElement as wrapRoot } from './src/components/RootElement'
import { CachesRegistry } from './src/lib/cache'
import '@fontsource/baloo-2/400.css'
import '@fontsource/baloo-2/700.css'
import '@fontsource/nunito/400.css'
import '@fontsource/nunito/700.css'
import 'react-toastify/dist/ReactToastify.css'
import './src/styles/index.css'

CachesRegistry.restore()

// gatsby-plugin-google-gtag v4 doesn't load in dev, so we load it manually
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined' && !window.gtag) {
  const script = document.createElement('script')
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-HGHKTPS5V7'
  script.async = true
  document.head.appendChild(script)
  window.dataLayer = window.dataLayer || []
  // eslint-disable-next-line
  window.gtag = function gtag() { window.dataLayer.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('config', 'G-HGHKTPS5V7', { send_page_view: true, debug_mode: true })
}

export const wrapRootElement = wrapRoot
